import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import { Report024Container } from 'app/containers/Report/Report024'
import { ModulePermissionEnum } from 'app/common/permission-module'

const AccountingReport024PageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.report_24)}</PageTitle>
      <Report024Container module={ModulePermissionEnum.ACCOUNTING} />
    </>
  )
}
const AccountingReport024Page = memo(AccountingReport024PageCpn, isEqual)

export default AccountingReport024Page
